import { withState, compose, withHandlers } from 'recompose';
import { convertAssignmentsIntoObject, getAssignment } from '../../utils';

const withServiceAssignments = compose(
  withState(
    'serviceAssignments',
    'setServiceAssignments',
    ({ service, roleIdType }) => {
      const assignments = roleIdType.type === 'brand' ?
        (service.assignments || []) :
        [{ ...service, assigneeId: roleIdType.id }];

      return convertAssignmentsIntoObject(assignments);
    },
  ),
  withHandlers({
    getAssignment: props => row => getAssignment(props.serviceAssignments, row),
  })
);

export default withServiceAssignments;
